import {IDeepLinkActionsFactoryService} from './deep-link-actions-factory.service.inteface';
import {ServiceBase} from '../../ServiceBase';
import {ICasinoDeepLinkAction} from "../casino-deep-link-action.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {DeepLinkActionsFactoryUnifiedStrategy} from "../unified/deep-link-action-factory/deep-link-actions-factory-unified.strategy";
import {DeepLinkActionsFactoryLegacyStrategy} from "../legacy/deep-link-action-factory/deep-link-actions-factory-legacy.strategy";

export class DeepLinkActionsFactoryService extends ServiceBase implements IDeepLinkActionsFactoryService {

  constructor(services: IServiceFactoryExtended) {
    super(services);
    this._strategies = [
        new DeepLinkActionsFactoryUnifiedStrategy(services),
        new DeepLinkActionsFactoryLegacyStrategy(services)
    ];
  }

  private readonly _strategies: IDeepLinkActionsFactoryService[];

  createActionFromCurrentRoute(): ICasinoDeepLinkAction | null {
    for(let strategy of this._strategies) {
      let action = strategy.createActionFromCurrentRoute();
      if(action) {
        return action;
      }
    }

    return null;
  }

  createActionFromDeepLinkObject(deepLinkObject: any): ICasinoDeepLinkAction | null {
    for(let strategy of this._strategies) {
      let action = strategy.createActionFromDeepLinkObject(deepLinkObject);
      if(action) {
        return action;
      }
    }

    return null;
  }

}
